import React from 'react';
import { useSip } from '../../pages/callPage/sipContext';
import './incomingCallPopup.css';
import { useNavigate } from 'react-router-dom';

export default function IncomingCallPopup() {
  const { incomingCall, setIncomingCall } = useSip();
  const navigate = useNavigate();

  if (!incomingCall) return null;

  const acceptCall = () => {
    if (incomingCall && incomingCall.session) {
      navigate('/user-dashboard/call', {
        replace: true,
        state: { pendingAccept: true, ctxid: incomingCall.ctxid }
      });
    }
  };

  const rejectCall = () => {
    if (incomingCall && incomingCall.session) {
      incomingCall.session.reject();
      setIncomingCall(null);
    }
  };

  return (
    <div className="sip-popup-overlay">
      <div className="sip-popup-container">
        <div className="sip-popup-icon-ring">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
          </svg>
        </div>
        <div className="sip-popup-content">
          <span className="sip-popup-label">Incoming Call</span>
          <span className="sip-popup-caller">{incomingCall.displayName}</span>
        </div>
        <div className="sip-popup-actions">
          <button className="sip-popup-btn reject" onClick={rejectCall}>
            Decline
          </button>
          <button className="sip-popup-btn accept" onClick={acceptCall}>
            Answer
          </button>
        </div>
      </div>
    </div>
  );
}
